<template>
  <div id="app">
    <header class="header">阿敦海量查名</header>
    <div class="content">
      <el-row>
        <el-input class="input" maxlength="1" placeholder="请输入一个你最喜欢的中文简体汉字，你会得到3000个名字，没有输入默认从爱开始" v-model="form.companyName"></el-input>
      </el-row>
      <el-row>
        <el-col :span="16">
          <el-radio-group v-model="form.location">
            <el-radio :label="0">文字在前</el-radio>
            <el-radio :label="1">文字在后</el-radio>
          </el-radio-group>
        </el-col>
        <el-col :span="8" style="padding:5px;">
          <el-button type="primary" @click="loadPageList">查询</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-tag
          v-for="tag in tags"
          :key="tag.key"
          closable
          @close="handleClose(tag)"
          >
          {{tag.name}}
        </el-tag>
      </el-row>
      <el-row>
        <el-button
          type="primary"
          style="text-align: right; margin: 10px 0px 0px 0px"
          v-clipboard:copy="message"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          >保存到粘贴板
        </el-button>
      </el-row>
      <el-row style="padding: 8px;">
        <el-input type="textarea" v-model="message"></el-input>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-row>
            <img src="../assets/微信.jpg" class="image">
          </el-row>
          <el-row>
            <span>微信</span>
          </el-row>
        </el-col>
        <el-col :span="2">
          <span>扫码打赏</span>
        </el-col>
        <el-col :span="11">
          <el-row>
            <img src="../assets/支付宝.jpg" class="image">
          </el-row>
          <el-row>
            <span>支付宝</span>
          </el-row>
        </el-col>
      </el-row>
      <v-loadmore :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" :auto-fill="false" ref="loadmore">
        <ul class="list">
          <li is="companyItem"
            v-for="(item,index) in data"
            :key="index" class="item"
            v-bind:id="index+1"
            v-bind:title="item.label"
            v-bind:good="item.isGood"
            v-on:toBeGoodOrNot="IsGoodOrNot(index)"
            >
          </li>
        </ul>
      </v-loadmore>
    </div>
  </div>
</template>
<script>
import {Loadmore} from 'mint-ui'
import companyItem from '@/components/Item'
export default {
  name: 'displayCompanyName',
  components: {
    'v-loadmore': Loadmore,
    'companyItem': companyItem
  },
  data () {
    return {
      scrollMode: 'auto', // 移动端弹性滚动效果，touch为弹性滚动，auto是非弹性滚动
      loading: false,
      allLoaded: false,
      data: [],
      isGood: false,
      initTag: {'key': 'test', 'name': '点击公司名称，它将记录在这里'},
      tags: [],
      location: 0,
      companyname: '',
      count: 0,
      message: '部分手机浏览器关闭访问粘贴板功能，可以在此处选定文本并粘贴',
      bottomText: '',
      form: {
        companyName: '',
        itemsPerPage: 20,
        location: 0,
        currentPage: 1
      }
    }
  },
  mounted () {
    // this.loadPageList() // 初次访问查询列表
    this.tags.push(this.initTag)
  },
  methods: {
    onCopy: function (e) {
      this.$message('您所挑选的名字已经拷贝到粘贴板，请打开记事本按crtl + v进行粘贴', 'success')
    },
    onError: function (e) {
      this.$message(e.message, 'error')
    },
    loadBottom: function () {
      // 上拉加载
      this.more()// 上拉触发的分页查询
      this.$refs.loadmore.onBottomLoaded()// 固定方法，查询完要调用一次，用于重新定位
    },
    loadPageList: function () {
      let vm = this
      this.data = []
      this.message = ''
      this.tags = []
      const loading = this.$loading({
        lock: true,
        text: '正在拼命从540万名字中查询，请稍等。。。',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      // 查询数据
      this.$ajax.post('/api/queryCompanies', this.form)
        .then(res => {
          res.data.pageResult.forEach(item => {
            vm.data.push({key: item.name, label: item.name, isGood: false})
          })
          this.$nextTick(function () {
          // 是否还有下一页，加个方法判断，没有下一页要禁止上拉
            this.scrollMode = 'touch'
          })
          loading.close()
        }).catch(function (error) {
          loading.close()
          vm.$message({
            showClose: true,
            duration: 0,
            type: 'error',
            message: error.response.data.detail
          })
        }).catch(function (error) {
          console.log(error.message)
          loading.close()
        }).catch(function (error) {
          loading.close()
          vm.$message({
            showClose: true,
            duration: 0,
            type: 'error',
            message: error.response.data.detail
          })
        })
    },
    IsGoodOrNot (index) {
      let vm = this
      let tmpTag = {name: this.data[index].key, key: this.data[index].label}
      if (this.tags.indexOf(this.initTag) !== -1) { this.tags.splice(this.tags.indexOf(this.initTag), 1) }
      this.data[index].isGood = !this.data[index].isGood
      // 为该公司名称点赞，此名称被记录到tag集合
      if (this.data[index].isGood) {
        this.tags.push(tmpTag)
        vm.message = ''
        this.tags.forEach(function (tag) {
          vm.message += tag.name + ' '
        })
      } else {
        // 如果取消为该公司名称点赞，则此名称从tag集合中去除
        this.tags.forEach(function (tag) {
          if (tag.key === tmpTag.key) {
            vm.tags.splice(vm.tags.indexOf(tag), 1)
          }
        })
        // this.tags.splice(this.tags.indexOf(tmpTag), 1)
        vm.message = ''
        this.tags.forEach(function (tag) {
          vm.message += tag.name + ' '
        })
      }
    },
    handleClose (tag) {
      let vm = this
      this.tags.splice(this.tags.indexOf(tag), 1)
      this.message = ''
      this.tags.forEach(function (tag) {
        vm.message += tag.name + ' '
      })
    },
    more: function () {
      let vm = this
      // 分页查询
      const loading = this.$loading({
        lock: true,
        text: '阿敦正在从540万名字中查询您所需要的，请稍等。。。',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.form.currentPage += 1
      this.$ajax.post('/api/queryCompanies', this.form)
        .then(res => {
          res.data.pageResult.forEach(item => {
            vm.data.push({key: item.name, label: item.name, isGood: false})
          })
          loading.close()
        }).catch(function (error) {
          loading.close()
          vm.$message({
            showClose: true,
            duration: 0,
            type: 'error',
            message: error.response.data.detail
          })
        }).catch(function (error) {
          console.log(error.message)
          loading.close()
        }).catch(function (error) {
          loading.close()
          vm.$message({
            showClose: true,
            duration: 0,
            type: 'error',
            message: error.response.data.detail
          })
        })
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #app {
        margin: 0 auto;
        text-align: center;
        background-color: #f5f5f5;
        padding: 0px 0;
    }
        #app .header {
        font-size: 28px;
    }
      .content {
        width: 90%;
        margin: 0 auto;
        box-shadow: 0 3px 3px 2px #00000040;
        position: relative;
    }
    .list {
      padding: 8px;
    }
    .item {
        display: flex;
        flex-direction: row;
        border-top: 1px solid #ccc;
        font-size: 24px;
        padding: 8px;
        background-color: white;
        align-items: left;
    }
    .item_content {
        flex: 1;
        text-align: left;
        margin-left: 16px;
        font-size: 20px;
        padding: 6px 0;
    }
    .apprieciate {
        position: absolute;
        right: 16px;
        color: #37fc99;
        padding: 10px;
    }
    .input {
        width: 90%;
        height: 56px;
        font-size:16px;
        border: 1px solid transparent;
    }
    .image {
    height: 80px;
    width: 80px;
  }
</style>



// WEBPACK FOOTER //
// src/components/DisplayCompanyName.vue